module.exports = __webpack_public_path__ + "media/2x/Z-a5cff29d.png";